import { render, staticRenderFns } from "./PromoPackages.vue?vue&type=template&id=0cc69328&scoped=true"
import script from "./PromoPackages.vue?vue&type=script&lang=ts"
export * from "./PromoPackages.vue?vue&type=script&lang=ts"
import style0 from "./PromoPackages.vue?vue&type=style&index=0&id=0cc69328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc69328",
  null
  
)

export default component.exports